import { z } from "zod";
import { toast } from "sonner";

import { BaseForm, FormInput } from "components/BaseForm";
import InvestigationStatusService from "services/InvestigationStatus";

// The API model requires the description key to be present, not to hold a
// value, and existing rows may carry NULL there. Keeping this a bare string
// means seeding "" satisfies the server while a rename-only edit of such a
// row still submits.
const schema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string(),
});

function InvestigationStatusForm({ model, onSuccess }) {
  const handleSubmit = async values => {
    if (model?.id) {
      await InvestigationStatusService.editInvestigationStatus(
        model.id,
        values.name,
        values.description
      );
    } else {
      await InvestigationStatusService.createInvestigationStatus(
        values.name,
        values.description
      );
    }
    toast.success("Investigation Status saved");
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{
        name: model?.name ?? "",
        description: model?.description ?? "",
      }}
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
    >
      <FormInput
        name="name"
        label="Name"
        placeholder="Investigation Status Name"
        required
        autoFocus
      />
      <FormInput
        name="description"
        label="Description"
        placeholder="Investigation Status Description"
      />
    </BaseForm>
  );
}

export default InvestigationStatusForm;
